<template>
  <div class="padding">
    <div style="margin-bottom: 24px; "><img src="../../assets/images/uupon@3x.png" style="max-width: 100%;" /></div>
    <div class="text-gray1">你今天嗶了嗎？</div>
    <div class="text-gray2">2021/10/1 ~ 2021/10/30 UUPON 會員使用悠遊付累積消費滿 1,800 元，可得 UUPON 點數 400 點 ( 限量 1000 名 )。</div>
    <div class="text-card">
      UUPON 會員需下載 EasyWallet App 並用
      <span>「同手機號碼」</span>
      註冊成為悠遊付會員，登記參加活動後始得計算累積消費金額。
    </div>

    <section class="agree-wrap" v-show="!is_bind">
      <div class="agree-label" style="margin-bottom: 16pt">
        <input type="checkbox" id="agree_recordToUupon_checked" v-model="agree_recordToUupon_checked" />
        <label for="agree_recordToUupon_checked" v-html="agree_personal"></label>
      </div>
      <div class="agree-label" style="margin-bottom: 16pt">
        <input type="checkbox" id="agree_terms_checked" v-model="agree_terms_checked" />
        <label for="agree_terms_checked">
          我已詳閱並同意
          <span>悠遊付搜集處理及利用個人資料告知事項</span>
        </label>
      </div>
    </section>

    <button class="btn btn-primary" :disabled="btn_disabled" @click="is_bind ? openExternalLink() : bind()">
      {{ is_bind ? '立即前往活動頁面' : '確認' }}
    </button>

    <template v-if="dialog">
      <div class="dialog">
        <div class="img-box">
          <img src="../../assets/images/recordtoUupon.png" />
        </div>
        <div class="dialog-text">
          <span>{{ cell_phone }}</span>
          授權成功
        </div>
        <div class="dialog-subtext">您已同意將 2021/10/1 ~ 2021/10/30 的消費紀錄傳送至 UUPON</div>
        <button class="btn btn-primary" @click="openExternalLink">立即前往活動頁面</button>
        <button class="btn btn-white" style="border: 0" @click="finish()">稍後再說</button>
      </div>
      <div class="dialog-mask"></div>
    </template>
  </div>
</template>
<script>
import { getUupayBindStatus, bindUupay } from '../../api/api';
import { mapActions } from 'vuex';

export default {
  name: 'UUPONEvent',
  data() {
    return {
      dialog: false,
      agree_recordToUupon_checked: false,
      agree_terms_checked: false,
      agree_personal: '我同意將我的<span>手機號碼、消費紀錄</span>傳送至<span>UUPON</span>',
      is_bind: true,
      cell_phone: '',
    };
  },
  mounted() {
    this.getBindStatus();
  },
  computed: {
    btn_disabled() {
      if (this.is_bind) {
        return false;
      } else {
        return !this.agree_recordToUupon_checked || !this.agree_terms_checked;
      }
    },
  },
  methods: {
    ...mapActions(['sentApp']),
    finish() {
      this.sentApp({
        action: 'finish',
        payload: null,
      });
    },
    getBindStatus() {
      getUupayBindStatus().then((res) => {
        this.is_bind = res.is_bind;
      });
    },
    bind() {
      bindUupay().then((res) => {
        if (!res.error) {
          this.cell_phone = res.cellphone;
          this.dialog = true;
        } else {
          alert(res.error.message);
        }
      });
    },
    openExternalLink() {
      this.sentApp({
        action: 'openExternalBrowser',
        payload: { url: 'https://uupon.tw' },
      });
    },
  },
};
</script>
<style type="text/css" lang="scss" scoped>
.padding {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.text-gray1 {
  font-size: 24px;
}

.text-gray2 {
  margin: 16px 0 24px 0;
}

.text-card {
  border: solid 1px rgba(64, 64, 64, 0.1);
  border-radius: 8pt;
  padding: 8px 16px;
  font-size: 14px;
  color: rgba(64, 64, 64, 0.75);
  text-align: justify;
  margin-bottom: 32px;

  span {
    font-family: PingFangTC-Medium;
    color: rgb(64, 64, 64);
  }
}

.agree-wrap {
  position: relative;

  .agree-label {
    color: rgba(64, 64, 64, 0.75);
    position: relative;

    label {
      text-align: left;
      display: inline-block;
      vertical-align: center;
      align-items: center;
      margin-left: 40px;
    }

    &:first-child {
      label span {
        font-family: PingFangTC-Medium;
        color: rgb(64, 64, 64);
      }
    }

    &:last-child {
      label span {
        font-family: PingFangTC-Medium;
        color: rgb(0, 122, 200);
      }
    }
  }

  .agree-label label::before {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}

.dialog {
  z-index: 99;
  left: 0;
  background-color: #fff;
  padding: 24px 20px;
  border-radius: 16pt;
  position: fixed;
  top: 50%;
  transform: translate(0, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 10%;

  .img-box {
    width: 100%;
    padding: 0 20pt 16pt 20pt;

    img {
      width: 100%;
    }
  }

  .dialog-text {
    text-align: center;
    font-size: 20px;

    span {
      color: rgb(0, 122, 200);
    }
  }

  .dialog-subtext {
    margin: 8px 0 32px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangTC-Regular;
    color: rgba(64, 64, 64, 0.75);
  }
}
</style>
